(function() {
  'use strict';

  // A directive to have ui-select open on focus
  angular.module('ringbaPortal').directive('uiSelectOpenOnFocus', uiSelectOpenOnFocus);

  function uiSelectOpenOnFocus (
    $timeout
  ) {
    const directive = {
      require: 'uiSelect',
      restrict: 'A',
      link: link
    };
    return directive;

    function link($scope, el, attrs, uiSelect) {
      let autoopen = true;

      angular.element(uiSelect.focusser).on('focus', function() {
        if (autoopen) {
          uiSelect.activate();
        }
      });

      // Disable the auto open when this select element has been activated.
      $scope.$on('uis:activate', function() {
        autoopen = false;
      });

      // Re-enable the auto open after the select element has been closed
      $scope.$on('uis:close', function() {
        autoopen = false;
        $timeout(function() {
          autoopen = true;
        }, 250);
      });
    }
  }
})();
